export default "__VITE_ASSET__Cw3fv37N__"